import { Col, message } from "antd";
import axios from "axios";
import { useEffect } from "react";
import { useState } from "react";
import LogoModal from "./components/LogoModal";
import Carousel_news_ticker from "./components/Carousel_news_ticker";
import { EditOutlined } from "@ant-design/icons";

const LogoList = ({
    permission
}) => {
    const [title, setTitle] = useState('修改');
    const [edit, setEdit] = useState(true);
    const [open, setOpen] = useState(false);
    const [color, setColor] = useState('d65b77');
    const [editcard, setEditCard] = useState({});
    const [messageApi, contextHolder] = message.useMessage();
    const [data, setData] = useState([])
    const [fileList, setFileList] = useState([]);


    const get_data = () => {
        axios
            .get('/cramSchool/api/blog/header/logo', { params: { "blog_type_id": 12 } })
            .then((response) => {
                setData(response.data.data);
                get_picture(response.data.data);
                let file_id = [];
                response.data.data.forEach(each_item => {
                    file_id = each_item.file_id
                })
                getLogoFile(file_id);
            })
    }
    const handleOnEdit = (key) => {
        data.map((value, index) => {
            if (index == 0) {
                setEditCard(value);
            }
        })
        setOpen(true)
    }
    const getLogoFile = (data_tmp) => {
        if (data_tmp.length != 0) {
            data_tmp && data_tmp.map((value, index) => {
                axios
                    .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": value } })
                    .then((response) => {
                        var blob_ = new Blob([response.data], {
                            type: "image/jpg",// this is the only MIME for SVG

                        });
                        const dataurl = URL.createObjectURL(blob_);
                        setFileList(prev => (
                            [
                                ...prev, {
                                    uid: [response.config.params.file_id],
                                    url: dataurl
                                }
                            ]
                        ));
                    })
            })
        }
    }
    const get_picture = (data_tmp) => {
        // console.log(data_tmp);
        data_tmp && data_tmp.map((value, index) => {
            let blog_id = value['blog_id']
            if (value.file_id.length != 0) {
                value.file_id.map((tmp, key) => {
                    // console.log(key, tmp);
                    // tmp['file_id']
                    axios
                        .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": tmp } })
                        .then((response) => {
                            var blob_ = new Blob([response.data], {
                                type: "image/jpg",// this is the only MIME for SVG

                            });
                            const dataurl = URL.createObjectURL(blob_);
                            setData(
                                (pre) => {
                                    return (
                                        pre.map((value, index) => {
                                            if (blog_id == value.blog_id) {
                                                if (value.file_url != undefined) {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [...value.file_url, dataurl]
                                                        }
                                                    )
                                                } else {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [dataurl]
                                                        }
                                                    )
                                                }
                                            } else {
                                                return (
                                                    { ...value }
                                                )

                                            }
                                        })
                                    )
                                }
                            )

                        })
                })
            }
        })
    }
    useEffect(() => {
        get_data();
    }, [])
    const handleEdit = (file_id) => {
        setFileList([])
        setOpen(false);

        var Today = new Date();
        let time = `${Today.getFullYear()}-${Today.getMonth() + 1}-${Today.getDate()}`;
        axios
            .patch(`/cramSchool/api/blog/header/logo`, [
                {
                    ...editcard,
                    file_id,
                    "blog_type_id": 12,
                    "title": 'logo',
                    "content": 'logo',
                    "annoucement_time": time,
                    "blog_id": 1
                }
            ])
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '修改失敗',
                    });
                    get_data();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '修改成功',
                    });
                    get_data();
                }
            })
        // console.log(editcard);
    }
    const handleSubmit = (file_id) => {
        if (JSON.stringify(editcard) == '{}') {
            // setOpen(false);
            messageApi.open({
                type: 'error',
                content: '新增失敗，請填寫任一欄位',
            });
        } else {
            if (editcard['annoucement_time'] == undefined) {
                var Today = new Date();
                editcard['annoucement_time'] = `${Today.getFullYear()}-${Today.getMonth() + 1}-${Today.getDate()}`;
            }
            axios
                .post(`/cramSchool/api/blog/header/logo`, [{ ...editcard, file_id, "blog_type_id": 12 }])
                .then((response) => {
                    if (response.data.status == 'failure') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: '新增失敗',
                        });
                        get_data();
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: '新增成功',
                        });
                        get_data();
                    }
                })
        }
        // console.log(editcard);
    }
    const handleDelete = (id) => {
        const deleterow = [{ "blog_id": id }];
        axios
            .delete('/cramSchool/api/blog/header/logo', {
                data: deleterow
            })
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '刪除失敗',
                    });
                    get_data();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '刪除成功',
                    });
                    get_data();
                }
            })

    }
    return (<>
        <LogoModal
            open={open}
            edit={edit}
            title={title}
            color={color}
            editcard={editcard}
            setEditCard={setEditCard}
            setOpen={setOpen}
            handleEdit={handleEdit}
            handleSubmit={handleSubmit}
            handleDelete={handleDelete}
        />
        <Col span={24}>
            <Carousel_news_ticker
                logo
                height={'100%'}
                file_url={fileList.map(map_item => map_item.url).length === 0 ? [{ uid: '/cram_school/mercylogo1.png', url: '/cram_school/mercylogo1.png' }] : fileList.map(map_item => map_item.url)}
                backgroundColor={'white'}
                href={'https://www.facebook.com/MERCYEnglishCenter'}
            />
            {permission ? <>
                <Col style={{ position: 'absolute', left: '90%', top: '0%' }}>
                    <EditOutlined
                        className='example'
                        style={{
                            backgroundColor: '#F9D4E5',
                            fontSize: '1.2rem',
                            borderRadius: '50%',
                            padding: '8px'
                        }}
                        onClick={e => handleOnEdit()}
                    />
                </Col>
            </> : null}
        </Col>
    </>)
}
export default LogoList